import { EmployeesGroup } from "features/EmployeesGroup/EmployeesGroup";
import { Employees } from "features/Employees/Employees";

import styles from "./styles.module.scss";

export const EmployeesPage = (): JSX.Element => (
  <div className={styles.main}>
    <EmployeesGroup />
    <Employees />
  </div>
);
